import { Marriage } from 'shell/models/person/marriage';
import { transformCitizen } from '../citizenship-shared';
import { transformEventData } from '../event-datas-shared';
import { transformGenerality } from '../registry-office/generality';
import { AccordionMarriage } from 'shell/components/shared/sipo-person-form/new-person';

export const transformMarriage = (values: AccordionMarriage | undefined): Marriage | undefined => {
  if (!values) {
    return undefined;
  }

  const {
    isForeign,
    eventDate,
    eventChoiceDate,
    exceptionalLocation,
    municipality,
    year,
    province,
    documentNumber,
    portion,
    range,
    regVol,
    office,
    documentDate,
    transcript,
  } = values || {};

  const coniuge = transformGenerality(values?.generality || {}, values?.person || {});

  const withCittadinanza = Boolean(
    values?.citizenship?.value ||
      values?.citizenship?.id ||
      values?.citizenshipCode ||
      values?.note ||
      values?.from
  );

  const cittadinanza = withCittadinanza
    ? transformCitizen({
        citizenship: values?.citizenship?.value || '',
        code: values?.citizenship?.id || values?.citizenshipCode || '',
        note: values?.note,
        validityDate: values?.from?.toFormat('dd/MM/yyyy') || '',
      })
    : undefined;

  const datiMatrimonio = transformEventData({
    isForeign,
    eventDate,
    eventChoiceDate,
    exceptionalLocation,
    municipality,
    year,
    province,
    documentNumber,
    portion,
    range,
    regVol,
    office,
    documentDate,
    transcript,
    location: {
      exceptionalLocation: values?.exceptionalLocation || '',
      localita:
        (!values?.isForeign
          ? values?.italian?.location
          : values?.foreign?.municipality?.description) || '',
      foreignState: values?.foreign?.state,
      municipality: values?.italian?.municipality,
    },
  });

  const originReturnData: Marriage | undefined = values
    ? {
        coniuge,
        cittadinanza,
        datiMatrimonio,
        ordineMatrimonio: values?.number?.toString() || undefined,
      }
    : undefined;

  return originReturnData;
};
